/*
Version 0.100

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2023.

!Changelog

2023
	10-03-2023
	- [BORN] This class is born. Hooray!

!Usage

	-
	
!Wishlist

	none
	
*/

var specific_booking_information = {};

(function () {

	// PRELOAD & DOCUMENT READY  *****************************************************************
	// PRELOAD & DOCUMENT READY *****************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************

	this.onready = function () {

		/*
		Change: Dropdown with person count
		*/
		$(document).on('change', '.js-count-people', function () {

			/*
			Loading: Start
			*/
			specific_loader.loading(1);

			/*
			Change maximum selectable dropdowns; maximum 14 people
			*/
			_check_adults = parseInt($('.js-count-people[data-category="adults"]').val());
			_check_children = parseInt($('.js-count-people[data-category="children"]').val());

			/*
			Adults need to be 1 or more
			*/
			if (_check_adults == 0) {
				$('.js-count-people[data-category="adults"]').val(1);
			}

			/*
			Calculate and edit the select values and hide the unavailable options
			topdown from adults to children
			$('.js-count-people['data-category="adults"]).val()
			$('.js-count-people['data-category="children"]).val()
			*/
			$('.js-count-people').each(function () {

				/*
				Adults
				*/
				if ($(this).attr('data-category') == 'adults') {
					_check_adults = parseInt($(this).val());
					if (_check_adults == 0) {
						$(this).val(1);
					}
					if (_check_adults > 14) {
						$(this).val(14);
					}
					$('.js-count-people[data-category="children"] option').each(function () {
						if (parseInt($(this).val()) > (14 - _check_adults)) {
							$(this).hide();
						} else {
							$(this).show();
						}
					});
				}

				/*
				Children
				*/
				if ($(this).attr('data-category') == 'children') {
					_check_children = parseInt($(this).val());
					if (_check_children > (14 - _check_adults)) {
						$(this).val(14 - _check_adults);
					}
				}

			});

			/*
			XHR
			*/
			$.ajax({
				url: globalUrl + '/a/a/booking-update-peoplecount',
				type: "POST",
				data: {
					count_adults: parseInt($('.js-count-people[data-category="adults"]').val()),
					count_children: parseInt($('.js-count-people[data-category="children"]').val()),
					count_babies: parseInt($('.js-count-people[data-category="babies"]').val())
				},
				headers: {
					'go-load': 1
				}
			})
				.done(function (data) {

					/*
					Nofitier
					*/
					specific_loader.notifier(
						1,
						0,
						'Uw gegevens zijn succesvol aangepast.'
					);

					/*
					Loading: Pause
					*/
					specific_loader.loading(0);

				})
				.always(function () {
				});

			/*
			Count people
			*/
			specific_booking_information.countPeople();

		});

		/*
		Form: Input
		Form: Input
		Form: Input
		Form: Input
		*/
		$(document).on('input', 'input', function () {

			/*
			Background color
			*/
			$(this).css({
				'background-color': '#fff'
			});

			/*
			Telephone
			*/
			_dialCode = iti.getSelectedCountryData().dialCode;
			_phoneNumber = $('.js-form-input-telephone_iti').val();
			_resetNumber = '+' + _dialCode + _phoneNumber;

			$('.js-form-input-telephone').val(_resetNumber);

		});

		if ($('.js-form-input-firstname').val() == '') {
			$('.js-form-input-firstname').css({
				'background-color': '#FFECC5'
			});
		}
		if ($('.js-form-input-lastname').val() == '') {
			$('.js-form-input-lastname').css({
				'background-color': '#FFECC5'
			});
		}
		if ($('.js-form-input-street').val() == '') {
			$('.js-form-input-street').css({
				'background-color': '#FFECC5'
			});
		}
		if ($('.js-form-input-zipcode').val() == '') {
			$('.js-form-input-zipcode').css({
				'background-color': '#FFECC5'
			});
		}
		if ($('.js-form-input-city').val() == '') {
			$('.js-form-input-city').css({
				'background-color': '#FFECC5'
			});
		}
		if ($('.js-form-input-email').val() == '') {
			$('.js-form-input-email').css({
				'background-color': '#FFECC5'
			});
		}
		if (
			$('.js-form-input-telephone').val() == '' ||
			$('.js-form-input-telephone').val().length <= 6
		) {
			$('.js-form-input-telephone_iti').css({
				'background-color': '#FFECC5'
			});
		}
		if ($('.js-form-input-birthdate').val() == '') {
			$('.js-form-input-birthdate').css({
				'background-color': '#FFECC5'
			});
		}

		/*
		Count people
		*/
		specific_booking_information.countPeople();

	};

	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************

	/*
	Calculate: Costs on People
	*/
	this.calculateCostsOnPeople = function () {

		var _count_adults = $('.js-count-people[data-category="adults"]').val();
		var _count_children = $('.js-count-people[data-category="children"]').val();
		//var _count_babies 	= $('.js-count-people[data-category="babies"]').val();
		var _costs_deposit = $('.js-costs-calculate[data-type="deposit"]').html();

		if (_count_adults == '' || _count_adults === undefined) {
			_count_adults = 0;
		}
		if (_count_children == '' || _count_children === undefined) {
			_count_children = 0;
		}
		if (_costs_deposit == '' || _costs_deposit === undefined) {
			_costs_deposit = 0;
		}

		var _costs_rent_text = $('.js-costs-calculate[data-type="rent"]').html() || '0,00';
		var _costs_rent = parseFloat(_costs_rent_text.replace(',', '.')) || 0;

		var _costs_bedlinnen = ((parseInt(_count_adults) * 15) + (parseInt(_count_children) * 15)).toFixed(2);
		var _costs_cleaning = (295.00).toFixed(2);

		var _count_nights = parseInt($('.js-booking-nights').val());
		var _costs_touristtax = (Math.round(parseInt(_count_adults) * 2.55 * 100) / 100 * _count_nights).toFixed(2); // PLUS 

		// Convert to cents for accurate calculation, then back to euros
		var _cents_rent = Math.round(parseFloat(_costs_rent) * 100);
		var _cents_bedlinnen = Math.round(parseFloat(_costs_bedlinnen) * 100);
		var _cents_cleaning = Math.round(parseFloat(_costs_cleaning) * 100);
		var _cents_touristtax = Math.round(parseFloat(_costs_touristtax) * 100);
		var _cents_deposit = Math.round(parseFloat(_costs_deposit) * 100);

		var _costs_total = ((_cents_rent + _cents_bedlinnen + _cents_cleaning + _cents_touristtax + _cents_deposit) / 100).toFixed(2);

		$('.js-costs-calculate[data-type="bedlinnen"]').html(_costs_bedlinnen.replace('.', ','));
		$('.js-costs-calculate[data-type="cleaning"]').html(_costs_cleaning.replace('.', ','));
		$('.js-costs-calculate[data-type="tax"]').html(_costs_touristtax.replace('.', ','));
		if (_costs_deposit != 0) {
			$('.js-costs-calculate[data-type="deposit"]').html(_costs_deposit.replace('.', ','));
		}

		/*
		Change , to .
		*/
		_costs_total = _costs_total.replace('.', ',');

		$('.js-costs-calculate[data-type="total"]').html(_costs_total);

	};

	/*
	Count: People
	*/
	this.countPeople = function () {

		/*
		Get: Adults, Children, Babies
		*/
		var _count_adults = $('.js-count-people[data-category="adults"]').val();
		var _count_children = $('.js-count-people[data-category="children"]').val();
		var _count_babies = $('.js-count-people[data-category="babies"]').val();

		var _total = parseInt(_count_adults) + parseInt(_count_children) + parseInt(_count_babies);

		$('.js-count-people-total').html(_total);

		/*
		Calculate: Costs on People
		*/
		specific_booking_information.calculateCostsOnPeople();

	};

}).apply(specific_booking_information); 